"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Loader, CircleCheck } from "lucide-react";
import { useEffect } from "react";
export default function FullOrderFormHome() {
  return <section id="orderform" className="bg-background ![padding:47px_0px_27px_0px]">
      <div className="container">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="mb-3 !text-[hsl(21,90%,48%)]">Направете поръчка</h2>
            <p className="text-muted-foreground">Попълнете формата по-долу и ще Ви уведомим за потвърдената поръчка, или се обади на 0888 007 342.</p>
          </div>

          <FormProvider className="card p-8" formId="full_order_form_home" sectionName="order-form-section" defaultValues={{
          name: "",
          phone: "",
          email: "",
          address: "",
          order_description: "",
          order_type: ""
        }} validationRules={{
          name: {
            required: true,
            minLength: 2,
            maxLength: 100
          },
          phone: {
            required: true,
            pattern: "phone"
          },
          email: {
            required: true,
            pattern: "email"
          },
          address: {
            required: true,
            minLength: 5
          },
          order_description: {
            required: true,
            minLength: 10
          },
          order_type: {
            required: true
          }
        }} submitText="Изпрати поръчка" successMessage="Благодарим ви! Вашата поръчка е получена успешно. Ще се свържем с вас скоро." errorMessage="Грешка при изпращане на поръчката. Моля, опитайте отново.">
            <OrderFormContent />
          </FormProvider>
        </div>
      </div>
    </section>;
}
function OrderFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  useEffect(() => {
    if (isSubmitted && !submitError) {
      window.location.href = 'https://mishmashinterpred.com/blagodarq-za-porachkata';
    }
  }, [isSubmitted, submitError]);
  if (isSubmitted && !submitError) return null;
  return <Form onSubmit={handleSubmit}>
      <FormField control={control} name="name" rules={{
      required: "Полето 'Име' е задължително",
      minLength: {
        value: 2,
        message: "Името трябва да е поне 2 символа"
      },
      maxLength: {
        value: 100,
        message: "Името не може да надвишава 100 символа"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Име</FormLabel>
            <FormControl>
              <Input placeholder="Иван Петров" {...field} />
            </FormControl>
            <FormDescription>Въведете вашето пълно име</FormDescription>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="phone" rules={{
      required: "Полето 'Телефон' е задължително",
      pattern: {
        value: /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/,
        message: "Моля, въведете валиден телефонен номер"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Телефон</FormLabel>
            <FormControl>
              <Input type="tel" placeholder="+359 88 123 4567" {...field} />
            </FormControl>
            <FormDescription>Въведете телефон за връзка</FormDescription>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "Полето 'Имейл' е задължително",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Моля, въведете валиден имейл адрес"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Имейл</FormLabel>
            <FormControl>
              <Input type="email" placeholder="ivan@example.com" {...field} />
            </FormControl>
            <FormDescription>Въведете валиден имейл адрес</FormDescription>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="address" rules={{
      required: "Полето 'Адрес' е задължително",
      minLength: {
        value: 5,
        message: "Адресът трябва да е поне 5 символа"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Адрес</FormLabel>
            <FormControl>
              <Input placeholder='ул. "Васил Levski" 10, София' {...field} />
            </FormControl>
            <FormDescription>Въведете точен адрес за доставка</FormDescription>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="order_description" rules={{
      required: "Полето 'Описание на поръчката' е задължително",
      minLength: {
        value: 10,
        message: "Описанието трябва да е поне 10 символа"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Описание на поръчката</FormLabel>
            <FormControl>
              <Textarea placeholder="Опишете какво желаете да поръчате..." className="min-h-32" {...field} />
            </FormControl>
            <FormDescription>Посочете ястия, количества и специални изисквания</FormDescription>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="order_type" rules={{
      required: "Моля, изберете тип на поръчката"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Тип на поръчката</FormLabel>
            <Select onValueChange={field.onChange} value={field.value}>
              <FormControl>
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Изберете тип на поръчката" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="Доставка" className="bg-white">Доставка</SelectItem>
                <SelectItem value="Вземане от място" className="bg-white">Вземане от място</SelectItem>
                <SelectItem value="На Място" className="bg-white">На Място</SelectItem>
              </SelectContent>
            </Select>
            <FormDescription className="text-muted-foreground text-base text-center !text-[hsl(21,90%,48%)] ![padding:7px_0px_7px_0px]">Фиксирана доставка: 2 евро</FormDescription>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 rounded-md bg-destructive/10 border border-destructive/20">
          <p className="text-destructive text-sm">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full btn-primary">
        {isSubmitting ? <>
            <Loader className="animate-spin size-4" />
            Изпращане...
          </> : "Изпрати поръчка"}
      </Button>
    </Form>;
}